import { BLUE_GREY_200, BLUE_GREY_400, BLUE_GREY_600, LILAC_400, LILAC_600, WHITE } from '../colors';
var dividerConfig = {
  theme: 'light',
  height: 2,
  isDarkMode: false,
  color: LILAC_400,
  shadowColor: WHITE,
  darkModeColor: LILAC_400,
  darkModeShadowColor: LILAC_600
};
var dividerWhiteConfig = {
  theme: 'white',
  height: 2,
  isDarkMode: false,
  color: BLUE_GREY_200,
  shadowColor: WHITE,
  darkModeColor: BLUE_GREY_400,
  darkModeShadowColor: BLUE_GREY_600
};
export default {
  light: dividerConfig,
  dark: dividerConfig,
  white: dividerWhiteConfig
};